import React, { useState } from 'react';
import './Footer.css';

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    if (email) {
      alert('Thank you for subscribing to our newsletter!');
      setEmail('');
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-column">
            <div className="footer-logo">
              <img 
                src="/images/logo.png.png" 
                alt="Ayodhya Natural Dairy Logo" 
                className="footer-logo-image"
              />
            </div>
            <p className="footer-description">
              Bringing the sacred traditions of Ayodhya to your doorstep. 
              Pure, natural, and trusted by thousands of families.
            </p>
          </div>
          <div className="footer-column">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#home">Home</a></li>
              <li><a href="#products">Products</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#testimonials">Testimonials</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          <div className="footer-column">
            <h4 className="footer-heading">Products</h4>
            <ul className="footer-links">
              <li><a href="#products">Pure Milk</a></li>
              <li><a href="#products">A2 Ghee</a></li>
              <li><a href="#products">Fresh Paneer</a></li>
              <li><a href="#products">Fresh Curd</a></li>
              <li><a href="#products">Buttermilk</a></li>
            </ul>
          </div>
          <div className="footer-column">
            <h4 className="footer-heading">Newsletter</h4>
            <p className="footer-newsletter-text">
              Subscribe to get updates on new products and special offers.
            </p>
            <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="newsletter-input"
              />
              <button type="submit" className="newsletter-btn">
                →
              </button>
            </form>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2023 Ayodhya Dairy. All rights reserved.
          </p>
          <div className="footer-legal">
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/terms-of-service">Terms of Service</a>
            <span>FSSAI Certified</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

